// components
import { MainComponent } from './main.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

export const MAIN_COMPONENTS: any[] = [
  MainComponent,
  PrivacyPolicyComponent,
];

// services



// WEBPACK FOOTER //
// ./src/app/components/dashboard/main/index.ts